import { jsx as b } from "react/jsx-runtime";
import { c as s } from "../../clsx-OuTLNxxd.js";
import { forwardRef as _ } from "react";
import '../../assets/IconButton.css';const t = {
  "icon-button": "_icon-button_1qz6r_1",
  "icon-button--destructive": "_icon-button--destructive_1qz6r_27",
  "icon-button--no-border": "_icon-button--no-border_1qz6r_35",
  "icon-button--wide": "_icon-button--wide_1qz6r_44"
}, a = _(
  ({ children: o, type: n = "button", variant: r, noBorder: c, wide: i, ...e }, u) => /* @__PURE__ */ b(
    "button",
    {
      ...e,
      className: s(t["icon-button"], {
        [t["icon-button--destructive"]]: r === "destructive",
        [t["icon-button--no-border"]]: c,
        [t["icon-button--wide"]]: i
      }),
      ref: u,
      type: n,
      children: o
    }
  )
);
export {
  a as IconButton
};
//# sourceMappingURL=IconButton.js.map
